import openSocket from "socket.io-client";
import { isObject } from "lodash";
import SocketWorker from "./SocketWorker"

export function socketConnection(params) {
  let userId = "";
  let companyId = "";
  let socketToken = "";
  if (isObject(params)){
    companyId = params?.user?.companyId
    userId = params?.user?.id
    socketToken = params?.user?.token
  }

  return SocketWorker(companyId, userId, socketToken)
}